export enum InvoiceCatMetodoPago {
  'Pago en una sola exhibición' = 'PUE',
  'Pago en parcialidades o diferido' = 'PPD',
}
